var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useSelector } from "react-redux";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import Checkbox from "@frameworks/NCD/Components/SearchPanelWithPopupFiltersLabel/Components/Checkbox";
import productBouquetActions from "@redux/feature/Markets/NCD/actions/ProductBouquetActions";
import BasicErrorMessage from "@frameworks/shared-library/components/BasicErrorMessage/BasicErrorMessage";
import React from "react";
import { nanoid } from "nanoid";
import { EOrderbookFilterTabs } from "@frameworks/NCD/Enum/OTC";
import InputComponent from "@frameworks/NCD/Components/InputComponent";
import CustomSelect from "@frameworks/NCD/Components/SearchPanelWithPopupFiltersLabel/Components/CustomSelect";
import { useLocation } from "react-router-dom";
import FundSearchPanel from "@frameworks/shared-library/components/Generic/FundSeachPanel/FundSearchPanel";
import ClientNamesWithCodes from "@frameworks/pmsjourney/components/ClientNameWithCodes/ClientNamesWithCodes";
export var useLocalFilterTabs = function (searchedClient, setSearchedClient) {
    var _a, _b;
    var cProductBouquetActions = new productBouquetActions();
    var location = useLocation();
    var isOrderBook = location.pathname.toLowerCase().includes("orderbook");
    var _c = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), subCategoryId = _c.subCategoryId, productRatingFilters = _c.productRatingFilters, productCouponFilters = _c.productCouponFilters, productInterestFrequencyFilters = _c.productInterestFrequencyFilters, productMaturityDateFilters = _c.productMaturityDateFilters, productPriceRangeFilters = _c.productPriceRangeFilters, productTypeFilters = _c.productTypeFilters, productIssuerNameFilters = _c.productIssuerNameFilters, productLocalRatingFilters = _c.productLocalRatingFilters, productLocalCouponFilters = _c.productLocalCouponFilters, productLocalInterestFrequencyFilters = _c.productLocalInterestFrequencyFilters, productLocalMaturityDateFilters = _c.productLocalMaturityDateFilters, productLocalPriceRangeFilters = _c.productLocalPriceRangeFilters, productLocalTypeFilters = _c.productLocalTypeFilters, productLocalIssuerNameFilters = _c.productLocalIssuerNameFilters, productLocalAvailableQuantityFilters = _c.productLocalAvailableQuantityFilters, productLocalMinInvestmentFilters = _c.productLocalMinInvestmentFilters, productAvailableQuantityFilters = _c.productAvailableQuantityFilters, productMinInvestmentFilters = _c.productMinInvestmentFilters, productLocalClientNameFilters = _c.productLocalClientNameFilters, productLocalStatusFilters = _c.productLocalStatusFilters, productLocalProductTypeFilters = _c.productLocalProductTypeFilters, productLocalInvestmentValueFilters = _c.productLocalInvestmentValueFilters;
    var _d = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }), productClientNameFilters = _d.productClientNameFilters, productStatusFilters = _d.productStatusFilters, productProductTypesFilters = _d.productProductTypesFilters, productInvestmentValueFilters = _d.productInvestmentValueFilters;
    var prependAllOption = function (data) { return __spreadArray([
        {
            name: "all",
            display: "All (".concat((data === null || data === void 0 ? void 0 : data.length) || 0, ")"),
            total_pages: 1,
            total_records: (data === null || data === void 0 ? void 0 : data.length) || 0,
        }
    ], __read((data || [])), false); };
    var prependAllOptionOrderBook = function (data) { return __spreadArray([
        {
            name: "all",
            value: "All (".concat((data === null || data === void 0 ? void 0 : data.length) || 0, ")"),
        }
    ], __read((data || [])), false); };
    var generateCheckbox = function (filtersData, selectedFiltersData, eventKey) {
        var handleFilterChange = function (e, selectedFilters) {
            var _a;
            if (selectedFilters === void 0) { selectedFilters = []; }
            var value = e.target.value;
            var allValues = (_a = filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (item) { return item === null || item === void 0 ? void 0 : item.name; })) !== null && _a !== void 0 ? _a : [];
            var newFilters = [];
            if (!filtersData) {
                console.warn("No filter data available");
                return;
            }
            switch (value) {
                case "all":
                    if ((selectedFilters !== null && selectedFilters !== void 0 ? selectedFilters : []).includes("all") ||
                        allValues.every(function (val) { return (selectedFilters !== null && selectedFilters !== void 0 ? selectedFilters : []).includes(val); })) {
                        newFilters = [];
                    }
                    else {
                        newFilters = allValues;
                    }
                    break;
                default:
                    var cleanedSelected = (selectedFilters !== null && selectedFilters !== void 0 ? selectedFilters : []).filter(function (v) { return v !== "all"; });
                    if (cleanedSelected.includes(value)) {
                        newFilters = cleanedSelected === null || cleanedSelected === void 0 ? void 0 : cleanedSelected.filter(function (v) { return v !== value; });
                    }
                    else {
                        newFilters = __spreadArray(__spreadArray([], __read(cleanedSelected), false), [value], false);
                    }
                    if (newFilters.length === allValues.length) {
                        newFilters = __spreadArray(["all"], __read(allValues), false);
                    }
                    break;
            }
            switch (eventKey) {
                case EOrderbookFilterTabs.Rating:
                    cProductBouquetActions.getLocalProductRatingFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.Type:
                    cProductBouquetActions.getLocalProductTypeFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.PriceRange:
                case EOrderbookFilterTabs.Price:
                    cProductBouquetActions.getLocalProductPriceRangeFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.PayoutFreq:
                    cProductBouquetActions.getLocalProductInterestFrequencyFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.MaturityDate:
                    cProductBouquetActions.getLocalProductMaturityDateFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.IssuerName:
                    cProductBouquetActions.getLocalProductIssuerNameFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.CouponFreq:
                    cProductBouquetActions.getLocalProductCouponFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.AvailableQuantity:
                    cProductBouquetActions.getLocalAvailableQuantityFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.MinInvestment:
                    cProductBouquetActions.getLocalMinInvestmentFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.ClientName:
                    cProductBouquetActions.getLocalClientNameFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.ProductType:
                    cProductBouquetActions.getLocalProductTypesFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.Status:
                    cProductBouquetActions.getLocalStatusFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.InvestmentValue:
                    cProductBouquetActions.getLocalInvestmentValueFilters(newFilters);
                    break;
                default:
                    console.warn("Unhandled eventKey: ".concat(eventKey));
                    break;
            }
        };
        var isNotData = (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) == 1 &&
            (filtersData === null || filtersData === void 0 ? void 0 : filtersData.some(function (item) {
                return (item === null || item === void 0 ? void 0 : item.name) === "all";
            }));
        return (React.createElement("div", { className: "client-names-radio-filters-container summary h-100" },
            React.createElement("div", { className: "d-flex flex-column overflow-auto scroll-bar h-100" }, !isNotData ? (filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (item) {
                var filterValue = isOrderBook ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.name;
                var rawDisplay = isOrderBook ? item === null || item === void 0 ? void 0 : item.value : item === null || item === void 0 ? void 0 : item.display;
                return (React.createElement(Checkbox, { key: nanoid(), list: {
                        display: rawDisplay,
                        value: filterValue,
                    }, checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        value: filterValue,
                        checked: selectedFiltersData === null || selectedFiltersData === void 0 ? void 0 : selectedFiltersData.some(function (f) {
                            return typeof f === "string"
                                ? f === filterValue
                                : (f === null || f === void 0 ? void 0 : f.name) === filterValue;
                        }),
                        onChange: function (e) { return handleFilterChange(e, selectedFiltersData); },
                    } }));
            })) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." })))));
    };
    var generateCheckboxFiltersForClients = function (filtersData, selectedFiltersData, eventKey) {
        var handleFilterChange = function (e, selectedFilters) {
            var _a;
            if (selectedFilters === void 0) { selectedFilters = []; }
            var value = e.target.value;
            var allValues = (_a = filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (item) { return item === null || item === void 0 ? void 0 : item.name; })) !== null && _a !== void 0 ? _a : [];
            var newFilters = [];
            if (!filtersData) {
                console.warn("No filter data available");
                return;
            }
            switch (value) {
                case "all":
                    if ((selectedFilters !== null && selectedFilters !== void 0 ? selectedFilters : []).includes("all") ||
                        allValues.every(function (val) { return (selectedFilters !== null && selectedFilters !== void 0 ? selectedFilters : []).includes(val); })) {
                        newFilters = [];
                    }
                    else {
                        newFilters = allValues;
                    }
                    break;
                default:
                    var cleanedSelected = (selectedFilters !== null && selectedFilters !== void 0 ? selectedFilters : []).filter(function (v) { return v !== "all"; });
                    if (cleanedSelected.includes(value)) {
                        newFilters = cleanedSelected.filter(function (v) { return v !== value; });
                    }
                    else {
                        newFilters = __spreadArray(__spreadArray([], __read(cleanedSelected), false), [value], false);
                    }
                    if (newFilters.length === allValues.length) {
                        newFilters = __spreadArray(["all"], __read(allValues), false);
                    }
                    break;
            }
            switch (eventKey) {
                case EOrderbookFilterTabs.Rating:
                    cProductBouquetActions.getLocalProductRatingFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.Type:
                    cProductBouquetActions.getLocalProductTypeFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.PriceRange:
                case EOrderbookFilterTabs.Price:
                    cProductBouquetActions.getLocalProductPriceRangeFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.PayoutFreq:
                    cProductBouquetActions.getLocalProductInterestFrequencyFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.MaturityDate:
                    cProductBouquetActions.getLocalProductMaturityDateFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.IssuerName:
                    cProductBouquetActions.getLocalProductIssuerNameFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.CouponFreq:
                    cProductBouquetActions.getLocalProductCouponFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.AvailableQuantity:
                    cProductBouquetActions.getLocalAvailableQuantityFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.MinInvestment:
                    cProductBouquetActions.getLocalMinInvestmentFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.ClientName:
                    cProductBouquetActions.getLocalClientNameFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.ProductType:
                    cProductBouquetActions.getLocalProductTypesFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.Status:
                    cProductBouquetActions.getLocalStatusFilters(newFilters);
                    break;
                case EOrderbookFilterTabs.InvestmentValue:
                    cProductBouquetActions.getLocalInvestmentValueFilters(newFilters);
                    break;
                default:
                    console.warn("Unhandled eventKey: ".concat(eventKey));
                    break;
            }
        };
        var generateMatchingName = function (text) {
            if (!searchedClient)
                return text;
            var parts = text.split(new RegExp("(".concat(searchedClient, ")"), "gi"));
            return parts.map(function (part, index) {
                return part.toLowerCase() === searchedClient.toLowerCase() ? (React.createElement("b", { key: index, className: "DMSansMedium_12_500" }, part)) : (part);
            });
        };
        return (React.createElement("div", { className: "client-names-radio-filters-container summary" },
            React.createElement(FundSearchPanel, { placeholder: "Search by client name", applySearchedFilters: function (value) {
                    setSearchedClient && setSearchedClient(value);
                }, searchValue: "", autoComplete: "off" }),
            React.createElement("div", { className: "d-flex flex-column justify-content-center" }, (filtersData === null || filtersData === void 0 ? void 0 : filtersData.filter(function (item) {
                var value = isOrderBook ? item.value : item.display;
                return searchedClient
                    ? value.toLowerCase().includes(searchedClient.toLowerCase())
                    : true;
            }).length) > 0 ? (filtersData === null || filtersData === void 0 ? void 0 : filtersData.filter(function (item) {
                var value = isOrderBook ? item.value : item.display;
                return searchedClient
                    ? value.toLowerCase().includes(searchedClient.toLowerCase())
                    : true;
            }).map(function (item) {
                var value = isOrderBook ? item.value : item.display;
                return (React.createElement(Checkbox, { key: nanoid(), list: {
                        display: (React.createElement(ClientNamesWithCodes, { clientName: value, clientCode: "", wrapClientName: true, searchText: "", generateMatchingName: generateMatchingName, parentClassName: "order-book-client-name" })),
                        value: value,
                    }, checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        value: value,
                        checked: selectedFiltersData === null || selectedFiltersData === void 0 ? void 0 : selectedFiltersData.some(function (f) {
                            return typeof f === "string" ? f === value : (f === null || f === void 0 ? void 0 : f.name) === value;
                        }),
                        onChange: function (e) {
                            return handleFilterChange(e, selectedFiltersData);
                        },
                    }, labelProps: { children: value } }));
            })) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." })))));
    };
    var generateFilterInputForClients = function () {
        return (React.createElement("div", { className: "summary aif-pms-order-book mt-4 mx-2" },
            React.createElement(CustomSelect, { updateSelectAumSize: function (option) { } }),
            React.createElement(InputComponent, { label: "", placeholder: "Enter Percentage", helperText: "", integer: true, value: "", onChangeEvent: function (event) { }, name: "Enter Percentage" })));
    };
    var commonTabs = {
        category: {
            title: "Category",
            eventKey: "Category",
            tabContent: generateCheckbox(prependAllOption(productRatingFilters === null || productRatingFilters === void 0 ? void 0 : productRatingFilters.data), productLocalRatingFilters, "Category"),
        },
        rating: {
            title: "Rating",
            eventKey: "Rating",
            tabContent: generateCheckbox(prependAllOption(productRatingFilters === null || productRatingFilters === void 0 ? void 0 : productRatingFilters.data), productLocalRatingFilters, EOrderbookFilterTabs.Rating),
        },
        couponFreq: {
            title: "Coupon Freq.",
            eventKey: "Coupon Freq.",
            tabContent: generateCheckbox(prependAllOption(productCouponFilters === null || productCouponFilters === void 0 ? void 0 : productCouponFilters.data), productLocalCouponFilters, EOrderbookFilterTabs.CouponFreq),
        },
        maturityDate: {
            title: "Maturity Date",
            eventKey: "Maturity Date",
            tabContent: generateCheckbox(prependAllOption(productMaturityDateFilters === null || productMaturityDateFilters === void 0 ? void 0 : productMaturityDateFilters.data), productLocalMaturityDateFilters, EOrderbookFilterTabs.MaturityDate),
        },
        type: {
            title: "Type",
            eventKey: "Type",
            tabContent: generateCheckbox(prependAllOption(productTypeFilters === null || productTypeFilters === void 0 ? void 0 : productTypeFilters.data), productLocalTypeFilters, EOrderbookFilterTabs.Type),
        },
        minInvestment: {
            title: "Min Investment",
            eventKey: "Min Investment",
            tabContent: generateCheckbox(prependAllOption(productMinInvestmentFilters === null || productMinInvestmentFilters === void 0 ? void 0 : productMinInvestmentFilters.data), productLocalMinInvestmentFilters, EOrderbookFilterTabs.MinInvestment),
        },
        issuerName: {
            title: "Issuer Name",
            eventKey: "Issuer Name",
            tabContent: generateCheckbox(prependAllOption(productIssuerNameFilters === null || productIssuerNameFilters === void 0 ? void 0 : productIssuerNameFilters.data), productLocalIssuerNameFilters, EOrderbookFilterTabs.IssuerName),
        },
        estYield: {
            title: "Est. Yield (%)",
            eventKey: "Est. Yield",
            tabContent: generateFilterInputForClients(),
        },
        payoutFreq: {
            title: "Payout Freq.",
            eventKey: "Payout Freq.",
            tabContent: generateCheckbox(prependAllOption(productInterestFrequencyFilters === null || productInterestFrequencyFilters === void 0 ? void 0 : productInterestFrequencyFilters.data), productLocalInterestFrequencyFilters, EOrderbookFilterTabs.PayoutFreq),
        },
        priceRange: {
            title: "Price Range (₹)",
            eventKey: "Price Range",
            tabContent: generateCheckbox(prependAllOption(productPriceRangeFilters === null || productPriceRangeFilters === void 0 ? void 0 : productPriceRangeFilters.data), productLocalPriceRangeFilters, EOrderbookFilterTabs.PriceRange),
        },
        availableQty: {
            title: "Available Quantity",
            eventKey: "Available Quantity",
            tabContent: generateCheckbox(prependAllOption(productAvailableQuantityFilters === null || productAvailableQuantityFilters === void 0 ? void 0 : productAvailableQuantityFilters.data), productLocalAvailableQuantityFilters, EOrderbookFilterTabs.AvailableQuantity),
        },
        price: {
            title: "Price (₹)",
            eventKey: "Price Range",
            tabContent: generateCheckbox(prependAllOption(productPriceRangeFilters === null || productPriceRangeFilters === void 0 ? void 0 : productPriceRangeFilters.data), productLocalPriceRangeFilters, EOrderbookFilterTabs.PriceRange),
        },
        productType: {
            title: "Product Type",
            eventKey: EOrderbookFilterTabs.ProductType,
            tabContent: generateCheckbox(prependAllOptionOrderBook(productProductTypesFilters === null || productProductTypesFilters === void 0 ? void 0 : productProductTypesFilters.data), productLocalProductTypeFilters, EOrderbookFilterTabs.ProductType),
        },
        status: {
            title: "Status",
            eventKey: "Status",
            tabContent: generateCheckbox(prependAllOptionOrderBook(productStatusFilters === null || productStatusFilters === void 0 ? void 0 : productStatusFilters.data), productLocalStatusFilters, EOrderbookFilterTabs.Status),
        },
        clientName: {
            title: "Client Name",
            eventKey: "Client Name",
            tabContent: generateCheckboxFiltersForClients(productClientNameFilters === null || productClientNameFilters === void 0 ? void 0 : productClientNameFilters.data, productLocalClientNameFilters, EOrderbookFilterTabs.ClientName),
        },
        investmentValue: {
            title: "Investment Value",
            eventKey: "Investment Value",
            tabContent: generateCheckbox(prependAllOptionOrderBook(productInvestmentValueFilters === null || productInvestmentValueFilters === void 0 ? void 0 : productInvestmentValueFilters.data), productLocalInvestmentValueFilters, EOrderbookFilterTabs.InvestmentValue),
        },
    };
    var localFilterTabs = (_a = {},
        _a[ESubProductIds.Bonds] = [
            commonTabs.rating,
            commonTabs.couponFreq,
            // commonTabs.estYield,
            commonTabs.maturityDate,
            commonTabs.type,
            commonTabs.minInvestment,
            commonTabs.issuerName,
        ],
        _a[ESubProductIds.NCD] = [
            commonTabs.rating,
            // commonTabs.estYield,
            commonTabs.payoutFreq,
            commonTabs.priceRange,
            commonTabs.availableQty,
            commonTabs.minInvestment,
        ],
        _a[ESubProductIds.StructuredProducts] = [
            commonTabs.rating,
            commonTabs.couponFreq,
            commonTabs.priceRange,
            commonTabs.minInvestment,
        ],
        _a[ESubProductIds.UnlistedShares] = [
            commonTabs.priceRange,
            commonTabs.minInvestment,
        ],
        _a);
    var localFilterTabsOrderBook = (_b = {},
        _b[ESubProductIds.Bonds] = [
            commonTabs.productType,
            commonTabs.status,
            commonTabs.clientName,
            commonTabs.investmentValue,
        ],
        _b[ESubProductIds.NCD] = [
            commonTabs.productType,
            commonTabs.status,
            commonTabs.clientName,
            commonTabs.investmentValue,
        ],
        _b[ESubProductIds.StructuredProducts] = [
            commonTabs.productType,
            commonTabs.status,
            commonTabs.clientName,
            commonTabs.investmentValue,
        ],
        _b[ESubProductIds.UnlistedShares] = [
            commonTabs.productType,
            commonTabs.status,
            commonTabs.clientName,
            commonTabs.investmentValue,
        ],
        _b);
    return isOrderBook
        ? localFilterTabsOrderBook[subCategoryId]
        : localFilterTabs[subCategoryId] || [];
};
